module.exports = {
  decodeTx: require('./decodeTransaction.js'),
  FunctionDecoder: require('./FunctionDecoder.js')
};
